import React from 'react'
import PropTypes from 'prop-types'

import TrackKey from './TrackKey'

const TrackKeys = ({ tracks, toggleOpen, clickTrackButton, editMode, assignmentEdits, setAssignmentEdits, pmResourceNames, profile_data }) => (
  <ul className="rt-track-keys">
    {tracks.map(track => (
      <TrackKey key={track.id} track={track} toggleOpen={toggleOpen} clickTrackButton={clickTrackButton} editMode={editMode} assignmentEdits={assignmentEdits} setAssignmentEdits={setAssignmentEdits} pmResourceNames={pmResourceNames} profile_data={profile_data}/>
    ))}
  </ul>
)

TrackKeys.propTypes = {
  tracks: PropTypes.arrayOf(PropTypes.shape({})),
  toggleOpen: PropTypes.func,
  clickTrackButton: PropTypes.func,
}

export default TrackKeys
